import React from "react";
import { Button, Column, Columns, Modal, Section, Title } from "@allxsmith/bestax-bulma";


export default function DeleteConfirmModal({onDelete, open, setOpen}){


    // TODO(bestax-migrate): `closeOnBlur` — bestax Modal background click closes when onClose is set; remove
    return (
        <Modal
            active={open}
            closeOnBlur
            onClose={() => setOpen(false)}
        >
            <Modal.Content>
                <Section style={{background: "white"}}>
                    <Columns isMultiline>
                        <Title>Delete Confirm</Title>
                    </Columns>
                    <Columns isMultiline>
                        <Column>
                            <Button
                                color={"success"}
                                onClick={onDelete}
                                isFullWidth
                            >
                                Confirm
                            </Button>
                        </Column>
                        <Column>
                            <Button
                                color={"info"}
                                onClick={() => setOpen(false)}
                                isFullWidth
                            >
                                Cancel
                            </Button>
                        </Column>
                    </Columns>
                </Section>
            </Modal.Content>
        </Modal>
    );

}